module.exports = __webpack_public_path__ + "img/logo-1.24c58b7a.png";